module.exports = __webpack_public_path__ + "img/next-2.4b9c356c.svg";